import { setError } from "../redux/reducers/api/errorOnRequest";
import { store } from "../redux/store";
import i18n from "./i18n";

export const throwErrorToastAsync = async (error: Error | any) => {
    const errorData = error?.response?.data;

    const message = (errorData && `${errorData?.detail || errorData?.title} `) || error?.message || i18n.t("common:MESSAGES.DEFAULT_ERROR");
    store.dispatch(
        setError({
            isVisible: true,
            message: message,
        }),
    );
};
